<template>
  <div class="order-info">
    <div class="head-line pa-3">
      <v-avatar :tile="false" :size="60" color="grey lighten-4 mr-3">
        <v-img :src="avatar" size></v-img>
      </v-avatar>
      <div class="headline name">{{ name }}</div>
      <v-btn color="primary" @click="charge = true">
        充值积分
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div style="background: white" class="mt-2 mb-2">
      <v-divider></v-divider>
      <v-layout class="text-xs-center">
        <v-flex xs6 class="pa-3" @click="toPointHistory">
          <div class="font-weight-bold numb">{{ myScore }}</div>
          <div>可用积分<span style="font-size: 12px">（点击查看记录）</span></div>
        </v-flex>
        <div class="ver-line"></div>
        <v-flex xs6 class="pa-3" @click="toBountyHistory">
          <div class="font-weight-bold numb">{{ myBounty }}</div>
          <div>感谢金<span style="font-size: 12px">（点击查看记录）</span></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </div>
    <v-list three-line subheader>
      <v-subheader>我的订单</v-subheader>
      <p class="pa-4 text-xs-center" v-if="!myOrders.length">您尚未解锁商城内的任何商品。</p>
      <v-list-tile v-for="order in myOrders" :key="order.id" avatar @click="checkProduct(order.product.gid)"
                   v-else>
        <v-list-tile-avatar>
          <v-avatar color="primary" v-if="order.product.id === 34" size="40">
            <span class="white--text headline">分</span>
          </v-avatar>
          <v-img :src="order.product.head_image_url" v-else></v-img>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-if="order.product.id === 34">积分购买</v-list-tile-title>
          <v-list-tile-title v-else>{{ order.product.item }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ order.updated_time }}</v-list-tile-sub-title>
          <v-list-tile-sub-title>ID：{{ order.out_trade_no }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-title></v-list-tile-title>
          <v-list-tile-title v-text="getAmount(order.total_fee, order.product.bounty_price)"
                             class="text-xs-right"></v-list-tile-title>
          <v-list-tile-sub-title class="text-xs-right">价格</v-list-tile-sub-title>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
    <v-dialog v-model="charge">
      <v-card>
        <v-card-title class="headline">充值积分</v-card-title>
        <v-card-text>
          <p>
            充值后的积分可被用于解锁各种挑战与课程。充值消费额的3%将以感谢金的形式分别发放给你以及赠送你陪伴积分的TA。现在就选择要充值的积分数量，开启更精彩的旅程!</p>
          <v-flex xs12 sm6>
            <v-text-field
                v-model="amount"
                label="填写所需充值的积分数额"
                single-line
                outline
            ></v-text-field>
          </v-flex>
          <div class="grey--text">合计：{{ (amount / 100).toFixed(2) }}元</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat="flat" @click="deposit(amount)">
            充值
          </v-btn>
          <v-btn color="gray lighten-1" flat="flat" @click="charge = false">
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="failDialog.open">
      <v-card>
        <v-card-title class="headline">{{ failDialog.title || '充值失败' }}</v-card-title>
        <v-card-text>
          <p>{{ failDialog.error }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="failAction">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getOrderList} from '@/api/mission'
import userApi from '@/api/user'

export default {
  data() {
    return {
      myOrders: [],
      charge: false,
      myBounty: '载入中...',
      myScore: '载入中...',
      amount: '',
      failDialog: {
        open: false,
        triggerDialog: '',
        code: 0,
        error: '',
        extra: {},
        title: ''
      }
    }
  },
  mounted() {
    this.queryOrder()

  },
  computed: {
    ...mapGetters([
      'avatar',
      'name',
    ]),
  },
  methods: {
    ...mapActions([
      'HideLoading',
      'HideSmLoading',
      'ShowSmLoading'
    ]),
    queryOrder() {
      userApi.getMyScore().then((res) => {
        this.myScore = res.myScore
        this.myBounty = res.myBounty
      })
      getOrderList().then(r => {
        this.myOrders = r
        this.HideLoading()
      })
    },
    getAmount(amount, bounty) {
      if (amount === -1) {
        return parseInt(bounty) + ' 感谢金'
      } else {
        return '￥ ' + amount.toFixed(2) / 100
      }
    },
    deposit(point) {
      this.ShowSmLoading()
      userApi.buyPoint(point).then(r => {
        this.wx.chooseWXPay({
          timestamp: r.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: r.nonceStr, // 支付签名随机串，不长于 32 位
          package: r.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: r.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: r.sign, // 支付签名
          success: (res) => {
            // 支付成功后的回调函数
            userApi.getMyScore().then((res) => {
              this.myScore = res.myScore
              this.myBounty = res.myBounty
              this.charge = false
              this.HideSmLoading()
            })
          },
          cancel: (res) => {
            this.HideSmLoading()
          },
          fail: res => {
            alert('未能支付成功，请重试或联系管理员。')
            this.HideSmLoading()
          }
        });
      }).catch(e => {
        this.HideSmLoading()
        if (e.response.status === 546) {
          this.failDialog = {...e.response.data, open: true}
        }
      })
    },
    checkProduct(pid) {
      if (pid !== 8) {
        this.$router.push({name: 'productDetail', params: {pid: pid}})
      }
    },
    toPointHistory() {
      this.$router.push({name: 'pointHistory'})
    },
    toBountyHistory() {
      this.$router.push({name: 'bountyHistory'})
    },
    failAction() {
      this.failDialog.open = false
    },
  }
}
</script>

<style lang="scss">
.order-info {
  .ver-line {
    width: 1px;
    background: rgba(0, 0, 0, 0.12);
  }

  .name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .head-line {
    background: white;
    display: flex;
    height: 120px;
    align-items: center;
  }

  .v-list__tile--avatar {
    height: 80px;
  }

  .numb {
    font-size: 20px;
    margin-bottom: 5px;
  }
}

</style>
